import { useContext } from 'react'
import { UserAccountContext } from '../contexts/UserAccountContext'
import type { UserAccountContextValue } from '../contexts/UserAccountContext'

export const useUserAccount = (): UserAccountContextValue => {
  const context = useContext(UserAccountContext)
  if (context === undefined) {
    throw new Error('useUserAccount must be used within a UserAccountProvider')
  }
  return context
}
